import React, { useState } from 'react';
import { Search, Inbox } from 'lucide-react';
import { OrderCard } from './OrderCard';

const FILTERS = [
  { k: 'all', label: 'Todos', on: 'bg-slate-900 text-white' },
  { k: 'late', label: 'Atrasados', on: 'bg-red-600 text-white' },
  { k: 'justo', label: 'Justos', on: 'bg-amber-500 text-white' },
  { k: 'espacio', label: 'Con espacio', on: 'bg-emerald-600 text-white' },
  { k: 'done', label: 'Terminados', on: 'bg-blue-600 text-white' },
];
const ORDER = { late: 0, justo: 1, espacio: 2, done: 3 };

export const PedidosTab = ({ PL, filter, setFilter, ...handlers }) => {
  const [q, setQ] = useState('');
  const list = PL
    .filter(({ o, pl }) => (filter === 'all' || pl.status === filter) && o.cliente.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => ORDER[a.pl.status] - ORDER[b.pl.status] || a.pl.margin - b.pl.margin);
  return (
    <div data-testid="tab-content-pedidos">
      <div className="flex flex-col md:flex-row gap-3 mb-5">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input data-testid="input-search-pedidos" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por cliente..."
            className="w-full pl-9 pr-3 py-2.5 text-sm border border-slate-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400" />
        </div>
        <div className="flex gap-1 p-1 bg-slate-100 rounded-xl overflow-x-auto">
          {FILTERS.map(({ k, label, on }) => (
            <button key={k} data-testid={`filter-${k}`} onClick={() => setFilter(k)}
              className={`px-3 py-1.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${filter === k ? on : 'text-slate-600 hover:bg-white'}`}>{label}</button>
          ))}
        </div>
      </div>
      {!list.length ? (
        <div className="bg-white border border-dashed border-slate-300 rounded-2xl p-10 text-center text-slate-500" data-testid="pedidos-empty">
          <Inbox className="mx-auto text-slate-400" size={32} />
          <p className="mt-3 font-medium">{PL.length ? 'Ningún pedido coincide con el filtro.' : 'No hay pedidos todavía.'}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">{list.map(({ o, pl }) => <OrderCard key={o.id} o={o} pl={pl} {...handlers} />)}</div>
      )}
    </div>
  );
};
